import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const ScrollReveal = ({ children, className = '', style = {}, delay = 0, threshold = 0.1, as: Component = 'div' }) => {
  const [ref, isVisible] = useIntersectionObserver({ threshold });
  
  return (
    <Component 
      ref={ref} 
      className={`${className} ${isVisible ? 'is-visible' : ''} scroll-reveal-base`}
      style={{
        ...style,
        animationDelay: `${delay}s`
      }}
    >
      {children}
    </Component>
  );
};

export default ScrollReveal;
